import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgRedux } from '@angular-redux/store';
import { CardInfoState } from './store/card-info.store';
import { CardInfoActions } from './+state/card-info.actions';
import { Observable } from 'rxjs';
import { Angulartics2 } from 'angulartics2';

import { CardBalance } from '@ridango/core';

@Injectable( {
    providedIn: 'root'
} )
export class CardInfoService {

    constructor(
        @Inject( 'ENV' ) private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<CardInfoState>,
        private actions: CardInfoActions,
        private angulartics2: Angulartics2,
    ) { }


    fetchBalance ( cardNumber ): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/tickets/web/cardtype/U/card/${cardNumber}/balance.json`;
        return this.http.get( url );
    }
    fetchTickets ( cardNumber ): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/tickets/web/cardtype/U/card/${cardNumber}/tickets.json`;
        return this.http.get( url );
    }
    fetchHistory ( cardNumber, from, to = null ): Observable<any> {        
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/tickets/from/${from}/to/${to}/card/${cardNumber}`;
        return this.http.get( url );
    }

    setCardNumber ( cardNumber: string ) {
        this.ngRedux.dispatch( this.actions.setCardNumber( cardNumber ) );
    }
    setBalance ( balance: CardBalance ) {
        this.ngRedux.dispatch( this.actions.setCardBalance( balance ) );
    }
    setTickets ( tickets ) {
        this.ngRedux.dispatch( this.actions.setCardTickets( tickets ) );
    }
    setHistory ( history ) {
        this.ngRedux.dispatch( this.actions.setHistory( history ) );
    }

    setLoading ( loading ) {
        this.ngRedux.dispatch( this.actions.setLoading( loading ) );
    }

    getPdf ( token, lang ) {
        // tslint:disable-next-line:max-line-length
        const payload = {
            token: token,
            lang: lang
        };
        // tslint:disable-next-line:max-line-length
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/cart/pdf/reciept/spa`;
        this.angulartics2.eventTrack.next({
            action: 'download',
            properties: { category: 'pdf', label: 'from CardInfoService' },
        });
        return this.http.post( url, payload, { responseType: 'blob' } );

    }


}
